import { PatientSimple } from '@dreryk/egabinet-patient-frontend-api';

import { Modal, ModalCancelButton, ModalCloseButton, ModalWidth } from '@dreryk/react-components';

import { translationKeys } from './translations';
import { PatientSimpleCreateForm } from './PatientSimpleCreateForm';
import { PatientSimpleCreateModalConfirmButton } from './PatientSimpleCreateModalConfirmButton';

export type PatientSimpleCreateModalProps = {
   readonly onClose: VoidFunction;
   readonly onSuccess: (patient: PatientSimple) => void;
};

export const PatientSimpleCreateModal = (props: PatientSimpleCreateModalProps): JSX.Element => {
   return (
      <Modal testId={'patientSimpleCreate'} title={translationKeys.addNewPatient} width={ModalWidth.NORMAL}>
         <PatientSimpleCreateForm>
            {({ handleSubmit, formState }) => (
               <>
                  <PatientSimpleCreateModalConfirmButton onSuccess={props.onSuccess} handleSubmit={handleSubmit} />
                  <ModalCancelButton onClick={props.onClose} shouldConfirmExit={formState.isDirty} />
                  <ModalCloseButton onClick={props.onClose} shouldConfirmExit={formState.isDirty} />
               </>
            )}
         </PatientSimpleCreateForm>
      </Modal>
   );
};
